import React from "react"
import { Link } from "gatsby"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import styled from "styled-components"
import Typography from "../../../Typography"
import { DownChevron } from "../../../Icons"
import { Location } from "../../../../styles/sharedStyles"

const { H300 } = Typography

const Item = styled.div`
  ${H300}
  padding: 0 16px;
  color: ${(props) => props.theme.colors.black900};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.orange800};
  }
`

const DownChevronSpacing = styled.div`
  display: inline-block;
  padding-left: 8px;
`

const MUIMenu = styled(Menu)`
  ul {
    list-style-type: none;
    li {
      &::before {
        background: none;
      }
    }
  }
`

class NavBarSubItems extends React.PureComponent {
  state = {
    anchorEl: null,
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { anchorEl } = this.state
    const { title, items } = this.props

    return (
      <React.Fragment>
        <Item
          aria-owns={anchorEl ? "dropdown" : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          {title}
          <DownChevronSpacing>
            <DownChevron width="12px" height="12px" margin="0" />
          </DownChevronSpacing>
        </Item>
        <MUIMenu
          id="dropdown"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {items.map((item, index) => {
            return (
              <Link to={item.internalLink} key={index + item.title}>
                <MenuItem onClick={this.handleClose}>
                  {(item.flag && item.title) && (
                    <Location>
                      {item.flag && item.flag.asset.url && (
                        <img
                          src={`${item.flag.asset.url}?w=24`}
                          style={{
                            marginRight: "12px",
                            maxWidth: "24px",
                          }}
                          alt={item.title || "Country"}
                        />
                      )}

                      <p>{item.title}</p>
                    </Location>
                  )}
                  {!item.flag && item.title && <p>{item.title}</p>}
                </MenuItem>
              </Link>
            )
          })}
        </MUIMenu>
      </React.Fragment>
    )
  }
}

export default NavBarSubItems
